export const menuItems = [
    {
        label: 'Home',
        path: '/',
        icon: '',
    },
    {
        label: 'Services',
        path: '/services',
        icon: '',
    },
    {
        label: 'Projects',
        path: '/projects',
        icon: '',
    },
    {
        label: 'Get a Quote',
        path: '/get-quote',
        icon: '',
    },
    {
        label: 'Emergency Services',
        path: '/emergency',
        icon: '',
    }
]
